module.exports = __webpack_public_path__ + "static/img/m_role.868e35d.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/tsz/m_role.png
// module id = e386
// module chunks = 7